import { ImageAspectRatio } from '@/common/types';
import {
  generateResponsiveImageAttributes,
  ResponsiveImageConfig,
} from '@/common/utils/imageUtils';
import classNames from 'classnames';
import React from 'react';

import styles from './ImageBlock.module.scss';

export interface ImageBlockProps {
  src: string;
  srcSet?: string;
  sizes?: string;
  alt?: string;
  aspectRatio?: ImageAspectRatio;
  isLazyLoad?: boolean;
  className?: string;
  responsive?: ResponsiveImageConfig;
}

export const ImageBlock: React.FC<ImageBlockProps> = ({
  src,
  srcSet,
  sizes,
  alt = 'eb-image-item',
  aspectRatio = 'square',
  isLazyLoad = true,
  className,
  responsive,
}) => {
  const styleClassName = classNames(styles.image_wrapper, styles[`aspect_ratio__${aspectRatio}`]);

  // Generate responsive image attributes if configuration is provided
  const imageAttributes = responsive ? generateResponsiveImageAttributes(src, responsive) : { src };

  // NOTE: Using img due to image optimization issue with next/image for valkyrie apps
  return (
    <div className={classNames(styleClassName, className)}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        className={styles.image_block}
        src={imageAttributes.src}
        srcSet={srcSet || imageAttributes.srcSet}
        sizes={sizes || imageAttributes.sizes}
        alt={alt}
        title={alt}
        loading={isLazyLoad ? 'lazy' : 'eager'}
        style={{ objectFit: 'cover' }}
        fetchPriority={isLazyLoad ? 'low' : 'high'}
        decoding={isLazyLoad ? 'async' : 'sync'}
      />
    </div>
  );
};
